module.exports = __webpack_public_path__ + "img/9788976962805.78ae0fad.jpg";